/// <reference path="DOMAttached.js" />
/// <reference path="TextResource.js" />
/// <reference path="Confirm.js" />

class FeedComment extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.deleteButton = this.el.querySelector('.deleteBtn');

		if (this.deleteButton != undefined) {
			this.safeObserve(this.deleteButton, 'click', (ev) => this.onDeleteClick(ev, this.el));
		}
	}

	onDeleteClick(ev, comment) {
		ev.preventDefault();
		ev.stopPropagation();
		this.dialogComment = comment;
		confirmAI(this.options.trReallyDelete, this.onDeleteConfirm.bind(this), this.onDeleteCancel.bind(this), true, true);
	}

	onDeleteConfirm() {
		var id = this.dialogComment.querySelector(".id").innerHTML;

		axios(new UrlTemplate(this.options.deleteUrl).r("PLH_smsgc", id).url, {
			method: 'get'
		}).then((response) => {
			this.onDeleted(this.dialogComment, response);
		});
	}

	onDeleteCancel() {}

	onDeleted(comment, res) {
		var json = res.data;

		if (json.success)
			comment.remove();
	}
}
